
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"38","height":"38","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"19","cy":"19","r":"19","fill":"#8200FF"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M15.202 10.1c.1-.1.2-.1.3-.1h.001c.05 0 .1.025.15.05.05.025.1.05.15.05l3.101 3.1c0 .05.025.1.05.15.025.05.05.1.05.15 0 .1 0 .2-.1.3l-.3.3c-.05 0-.1.025-.15.05-.05.025-.1.05-.15.05-.1 0-.2 0-.3-.1l-1.802-1.8v4.4c0 .4-.3.7-.701.7-.4 0-.7-.3-.7-.7v-4.4L13 14.1c-.05 0-.1.025-.15.05-.05.025-.1.05-.15.05-.1 0-.2 0-.3-.1l-.3-.3c0-.05-.025-.1-.05-.15-.025-.05-.05-.1-.05-.15 0-.1 0-.2.1-.3l3.102-3.1zm4.2 5.8c0-2 1.603-3.6 3.605-3.6h-.001c1.9 0 3.502 1.6 3.502 3.6v2.5c0 .5-.501 1-1.001 1-.5 0-1-.4-1-1v-2.5c0-.8-.701-1.5-1.502-1.5-.8 0-1.5.7-1.5 1.5v3.6h1.002c.5 0 1 .4 1 1v7.1c0 .5-.401 1-1.001 1H13.3c-.5 0-1-.4-1-1v-7.1c0-.5.4-1 1-1h6.103v-3.6zm-1 10.1v-1.1c.6-.2 1-.7 1-1.4 0-.8-.7-1.5-1.5-1.5s-1.5.7-1.5 1.5c0 .6.4 1.2 1 1.4V26c0 .3.2.5.5.5s.5-.2.5-.5z","fill":"#fff"}})])
          )
        }
      }
    